import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: null,
  props: {},
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (state, { payload: { type, modal, props } }) => {
      state.type = type;
      state.modal = modal;
      state.props = props;
    },
    hideModal: () => initialState,
  },
});

export const { showModal, hideModal } = modalSlice.actions;

export default modalSlice.reducer;
